module.exports = __webpack_public_path__ + "assets/img/0e68-za.svg";